// extracted by mini-css-extract-plugin
export default {"scoreWrappper":"styles_scoreWrappper__eOE8g","callScoreWrapper":"styles_callScoreWrapper__dKDWa","score":"styles_score__lA8ly","callScore":"styles_callScore__DMYZc"};